import {useToast} from "vue-toastification";

const toast = useToast();

export function showMessage(msg = '', type = '', timer = 1500, closeButton = false, position = 'top-right', bodyClassName = '') {
  if (type === 'error') {
    toast.error(msg, {
      timeout: timer,
    });
  }
  if (type === 'warning') {
    toast.warning(msg, {
      timeout: timer,
      position: position,
      bodyClassName: bodyClassName
    });
  }
  if (type === 'success') {
    toast.success(msg, {
      timeout: 500
    });
  }
}
